import { ServiceEntryFileDescriptor } from './service-entry-form-state';

/**
 * Extracts the file name from a ServiceEntryFileDescriptor.
 * Handles both File objects and string file references.
 *
 * @param data - The file descriptor containing either a File object or string
 * @returns The file name as a string
 */
export const getFileName = (data: ServiceEntryFileDescriptor): string => {
    return typeof data.file === 'string' ? data.file : data.file.name;
};
